import React, { useCallback } from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import type { IInputProps } from 'components/uiKit/Input'
import Input from 'components/uiKit/Input'

const FieldInput = ({ name, onChange, ...rest }: AdapterKitControlProps<IInputProps, string>) => {
  const handleChange = useCallback((value: string) => onChange({ name, value }), [name, onChange])

  return <Input {...rest} name={name} onChange={handleChange} />
}

export default React.memo(FieldInput) as typeof FieldInput
